module.exports = __webpack_public_path__ + "static/img/102412.5e2495c7.png";